import React, { useState } from "react";
import { Paper, Tabs, Tab } from "@material-ui/core";
import { TechSpecsNav } from '../../elements'
import AircraftConfig from './AircraftConfig';
import AircraftOverview from './AircraftOverview';
import AircraftWeight from './AircraftWeight';
import MajorAssemblies from './MajorAssemblies';
import LinkSvEvents from "./LinkSvEvents";
import { STabsLoader } from "../../shared_elements";
const Aircraft = ({assetInfoData, getResponseBack, skeletonLoader}) => {
    const [tabIndex, setTabIndex] = useState('details');
    return(
        <div>
            <Paper elevation={0} className="console-paper" style={{margin:'0px 10px 2px 10px'}}>
                {skeletonLoader ?<STabsLoader count={5} />:
                <Tabs indicatorColor="primary" value={tabIndex} onChange={(event, newValue) => setTabIndex(newValue)} variant='fullWidth'>
                    <Tab label="Basic Details" value={'details'} />
                    <Tab label="Acquisition & Other Details" value={'configuration'} />
                    <Tab label="Weight Variants" value={'weight-variants'}/>
                    <Tab label="Major Assemblies" value={'major-assemblies'}/>
                    <Tab label="Sv Events" value={'sv-events'}/>
                </Tabs>}
            </Paper>   
            { tabIndex === 'details' ? <AircraftOverview assetInfoData={assetInfoData} getResponseBack={getResponseBack}/>:null}        
            { tabIndex === 'configuration' ? <AircraftConfig assetInfoData={assetInfoData} getResponseBack={getResponseBack}/>:null}        
            { tabIndex === 'weight-variants' ? <AircraftWeight assetInfoData={assetInfoData}/>:null}        
            { tabIndex === 'major-assemblies' ? <MajorAssemblies assetInfoData={assetInfoData}/>:null}    
            { tabIndex === 'sv-events' ? <LinkSvEvents assetInfoData={assetInfoData} />:null}        
        </div>
    )
}
export default Aircraft;